"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.soapMessagesFactory = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const evidence_1 = require("../../../../composite/evidence/evidence");
const messages_fields_1 = require("./messages-fields");
const messages_columns_1 = require("./messages-columns");
const authored_evidence_1 = require("../../../../composite/evidence/authored-evidence/authored-evidence");
function soapMessagesFactory({ exportTag, url, }) {
    return function SoapMessages() {
        const intl = react_intl_1.useIntl();
        const evidence = authored_evidence_1.useAuthoredEvidence({
            identifier: 'SOAP_MESSAGES2',
            apiProps: {
                url,
            },
            tableProps: {
                reportTag: exportTag,
                columns: messages_columns_1.useColumns(),
                tableName: intl.formatMessage({
                    id: 'EAS_SOAP_LOGGER_MESSAGES_TABLE_TITLE',
                    defaultMessage: 'SOAP komunikace',
                }),
            },
            detailProps: {
                FieldsComponent: messages_fields_1.MessagesFields,
            },
        });
        return react_1.default.createElement(evidence_1.Evidence, Object.assign({}, evidence));
    };
}
exports.soapMessagesFactory = soapMessagesFactory;
soapMessagesFactory.useColumns = messages_columns_1.useColumns;
soapMessagesFactory.Fields = messages_fields_1.MessagesFields;
//# sourceMappingURL=messages.js.map